/**
* DO NOT EDIT MANUALLY
* This is an auto-generated file.
* Any changes will be overwritten.
*/
import{o as e,t,u as n}from"vendor/lit";import{a as r,r as i,t as a}from"vendor/decorate";var o=class extends t{static{this.styles=[n`
      :host {
        display: block;
        position: relative;
        z-index: 50;
      }

      aside {
        background-color: #fff;
        padding: calc(5 * var(--space-unit)) var(--gutter);
        display: flex;
        gap: calc(2 * var(--space-unit));
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-family: var(--navigation-font-family);
        font-size: calc(var(--body-font-size) * 0.1rem);
        position: relative;

        @media (width >= 768px) {
          gap: calc(4 * var(--space-unit));
          flex-direction: row;
        }

        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 24px;
          height: 24px;
          background-color: #fff;
          transform: translateX(-50%) translateY(15%) rotate(45deg);
        }
      }

      img {
        width: 157px;
        height: 31px;
      }

      h2 {
        font-family: var(--navigation-font-family);
        font-size: calc(var(--body-font-size) * 0.1rem);
        font-weight: normal;
        margin: 0;
      }

      .button-wrapper {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        justify-content: center;
        gap: calc(2 * var(--space-unit));
      }

      .button {
        --icon-size: 24px;

        white-space: nowrap;
        border: none;
        outline: none;
        border-radius: 20px;
        padding: calc(0.25 * var(--space-unit)) calc(3 * var(--space-unit))
          calc(0.5 * var(--space-unit)) calc(2 * var(--space-unit));
        line-height: 1;
        font-weight: bold;
        font-size: calc(var(--body-font-size) * 0.875 * 0.1rem);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        background-color: #f00;
        text-decoration: none;
        font-family: inherit;
      }

      .button__primary {
        gap: calc(0.5 * var(--space-unit));

        kanter-icon {
          --icon-size: 18px;
          --icon-stroke-width: 2px;
        }
      }

      .button__secondary {
        background-color: #f4f3f0;
        color: rgb(var(--text-color) / 0.75);

        kanter-icon {
          color: rgb(var(--text-color) / 0.2);

          --icon-size: 26px;

          transform: rotate(-90deg);
        }
      }
    `]}constructor(){super(),this.isBannerVisible=!1,this.dismissBanner=()=>{this.isBannerVisible=!1;let e=new URL(window.location.href);e.searchParams.get(`source`)===`redirect_pst`&&(e.searchParams.delete(`source`),window.history.replaceState({},``,e.toString()))};let e=new URLSearchParams(window.location.search);this.isBannerVisible=e.get(`source`)===`redirect_pst`}render(){return this.isBannerVisible?e`
      <aside>
        <img
          src="https://cdn.shopify.com/s/files/1/0814/6321/4354/files/PST_Kanter-logo-horizontal.png?v=1750261893"
          alt="PST and Kanter Logos"
          width="314"
          height="62"
        />

        <h2>You’ve been redirected because PST has joined Kanter</h2>

        <div class="button-wrapper">
          <button
            type="button"
            data-ph-id="pst-banner"
            @click=${this.dismissBanner}
            class="button button__primary"
          >
            <kanter-icon icon="crossClose"></kanter-icon>
            <span>Dismiss</span>
          </button>

          <a
            href="/pages/pst-joins-kanter"
            class="button button__secondary"
            data-ph-id="pst-banner"
            @click=${this.dismissBanner}
          >
            <kanter-icon icon="caret"></kanter-icon>
            <span>Learn more</span>
          </a>
        </div>
      </aside>
    `:null}};a([i()],o.prototype,`isBannerVisible`,void 0),o=a([r(`kanter-pst-announcement-banner`)],o);